import { useState, useId } from 'react'
import { Props_SnippetHiringProcess } from './HiringProcess.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetHiringProcess = (props: Props_SnippetHiringProcess) => {
    const { heading, repeatable_cards } = props

    const [activeIndex, setActiveIndex] = useState(0)
    const snippetId = useId()
    const headingHidden = !heading.visibility?.value

    return (
        <section className="snippet-hiring-process">
            <div className="snippet-hiring-process__container">
                <h2 className={`snippet-hiring-process__heading${headingHidden ? ' snippet-hiring-process__heading--hidden' : ''}`}>
                    {heading.text.value}
                </h2>
                <div className="snippet-hiring-process__container-content">
                    <ol className="snippet-hiring-process__container-cards">
                        {repeatable_cards.map(({ cardHeading, cardText }, index) => (
                            <li
                                key={`snippet-hiring-process-${snippetId}-card-${index}`}
                                className={`snippet-hiring-process__card${activeIndex === index ? ' snippet-hiring-process__card--active' : ''}`}
                                onMouseEnter={() => setActiveIndex(index)}
                                onMouseLeave={() => setActiveIndex(0)}
                            >
                                <div className="snippet-hiring-process__card-badge" aria-hidden="true">
                                    <span className="snippet-hiring-process__card-badge-number">
                                        {index + 1}
                                    </span>
                                </div>
                                <div className="snippet-hiring-process__card-content">
                                    <h3 className="snippet-hiring-process__card-heading">
                                        {cardHeading?.value}
                                    </h3>
                                        <div className="snippet-hiring-process__card-text">
                                            {cardText?.value && CompileMarkdown(cardText.value)}
                                        </div>
                                </div>
                            </li>
                        ))}
                    </ol>
                    <div className="snippet-hiring-process__container-image" aria-hidden="true">
                        {repeatable_cards.map(({ cardImage, cardImageAlt }, index) => cardImage?.value && (
                            <img
                                key={`snippet-hiring-process-${snippetId}-card-image-${index}`}
                                className={`snippet-hiring-process__card-image${activeIndex === index ? ' snippet-hiring-process__card-image--active' : ''}`}
                                src={cardImage.value}
                                alt={cardImageAlt?.value || ''}
                                loading="lazy"
                                width="470"
                                height="800"
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SnippetHiringProcess
